import React from 'react';
import Icon from '../../../components/AppIcon';

const FloorTypeStats = ({ floorTypes }) => {
  const stats = [
    {
      label: 'Total Floor Types',
      value: floorTypes?.length,
      icon: 'Grid3x3',
      color: 'var(--color-primary)'
    },
    {
      label: 'Active',
      value: floorTypes?.filter(ft => ft?.isActive)?.length,
      icon: 'Eye',
      color: 'var(--color-success)'
    },
    {
      label: 'Inactive',
      value: floorTypes?.filter(ft => !ft?.isActive)?.length,
      icon: 'EyeOff',
      color: 'var(--color-secondary)'
    },
    {
      label: 'Avg Price',
      value: floorTypes?.length > 0
        ? `$${(floorTypes?.reduce((sum, ft) => sum + parseFloat(ft?.price), 0) / floorTypes?.length)?.toFixed(2)}`
        : '$0.00',
      icon: 'DollarSign',
      color: 'var(--color-accent)'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {stats?.map((stat, index) => (
        <div
          key={index}
          className="bg-card border border-border rounded-lg p-4 transition-all duration-150 hover:shadow-md"
        >
          <div className="flex items-center justify-between mb-3">
            <div
              className="w-10 h-10 rounded-lg flex items-center justify-center"
              style={{ backgroundColor: `${stat?.color}15` }}
            >
              <Icon name={stat?.icon} size={20} color={stat?.color} />
            </div>
          </div>
          <div>
            <p className="text-2xl font-bold text-text-primary mb-1">
              {stat?.value}
            </p>
            <p className="text-sm text-text-secondary">
              {stat?.label}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FloorTypeStats;